import { type ReactNode } from 'react';
import styles from './accordion.module.scss';
import kebabCase from 'lodash/kebabCase';
import MarkdownParser from 'components/rich-text/markdown-parser';
type AccordionItem = {
	id?: string;
	_ref?: string;
	body: ReactNode;
	heading: string;
	jsxHeading?: never;
};

type AccordionItemWithJSXHeading = {
	id: string;
	_ref?: string;
	body: ReactNode;
	heading?: never;
	jsxHeading: ReactNode;
};

export interface IProps {
	accordionItems: AccordionItem[] | AccordionItemWithJSXHeading[];
}

export const Accordion = ({ accordionItems = [] }: IProps) => {
	return (
		<div className={styles.accordion}>
			{accordionItems?.map(
				(item: AccordionItem | AccordionItemWithJSXHeading, i) => {
					return (
						<details
							className={styles.details}
							key={item?.id || item?._ref || `accordion-item-${i}`}
						>
							<summary className={styles.summary}>
								<div className={styles.button}>
									{item.jsxHeading ?? (
										<div className={styles.heading}>
											<MarkdownParser>{item.heading}</MarkdownParser>
										</div>
									)}
								</div>
							</summary>
							<div
								className={styles.body}
								id={kebabCase(item.id) || kebabCase(item.heading)}
							>
								{item.body}
							</div>
						</details>
					);
				},
			)}
		</div>
	);
};

export default Accordion;
